import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { MaintenancePageLayout } from '@commercetools-frontend/application-components';
import UnexpectedErrorSVG from '@commercetools-frontend/assets/images/unexpected-error.svg';
import { jsx } from '@emotion/react/jsx-runtime';

var messages = defineMessages({
  title: {
    id: 'ErrorApologizer.title',
    defaultMessage: 'Sorry! An unexpected error occured.'
  },
  notifiedTeam: {
    id: 'ErrorApologizer.notifiedTeam',
    defaultMessage: 'Our team has been notified about this issue.'
  }
});

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const ErrorApologizer = () => {
  const intl = useIntl();
  return jsx(MaintenancePageLayout, {
    imageSrc: UnexpectedErrorSVG,
    title: jsx(FormattedMessage, _objectSpread({}, messages.title)),
    label: intl.formatMessage(messages.title),
    paragraph1: jsx(FormattedMessage, _objectSpread({}, messages.notifiedTeam))
  });
};
ErrorApologizer.displayName = 'ErrorApologizer';

export { ErrorApologizer as default };
